/**
 * Array of dummy Canadian postal codes
 * Format: A1A 1A1 (letter-number-letter space number-letter-number)
 * These can be used across different webforms for testing or default values
 */
const canadianPostalCodes = [
'FSA',
'H3B',
'H3C',
'H3E',
'H3G',
'H3H',
'H3J',
'H3K',
'H3L',
'H3M',
'H3N',
'H3P',
'H3R',
'H3S',
'H3T',
'H3V',
'H3W',
'H3X',
'H3Y',
'H3Z',
'H4A',
'H4B',
'H4C',
'H4E',
'H4G',
'H4H',
'H4J',
'H4K',
'H4L',
'H4M',
'H4N',
'H4P',
'H4R',
'H4S',
'H4T',
'H4V',
'H4W',
'H4X',
'H4Y',
'H7A',
'H7B',
'H7C',
'H7E',
'H7G',
'H7H',
'H7J',
'H7K',
'H7L',
'H7M',
'H7N',
'H7P',
'H7R',
'H7S',
'H7T',
'H7V',
'H7W',
'H7X',
'H7Y',
'H8N',
'H8P',
'H8R',
'H8S',
'H8T',
'H8Y',
'H8Z',
'H9A',
'H9B',
'H9C',
'H9E',
'H9G',
'H9H',
'H9J',
'H9K',
'H9P',
'H9R',
'H9S',
'H9W',
'H9X',
'J0A',
'J0B',
'J0C',
'J0E',
'J0G',
'J0H',
'J0J',
'J0K',
'J0L',
'J0N',
'J0P',
'J0R',
'J0S',
'J0T',
'J0V',
'J0W',
'J0X',
'J1A',
'J1E',
'J1G',
'J1H',
'J1J',
'J1L',
'J1N',
'J1R',
'J1X',
'J2B',
'J2C',
'J2G',
'J2H',
'J2J',
'J2K',
'J2L',
'J2M',
'J2R',
'J2S',
'J2T',
'J2W',
'J2X',
'J2Y',
'J3A',
'J3B',
'J3E',
'J3G',
'J3H',
'J3L',
'J3M',
'J3N',
'J3P',
'J3R',
'J3T',
'J3V',
'J3X',
'J3Y',
'J3Z',
'J4B',
'J4G',
'J4H',
'J4J',
'J4K',
'J4L',
'J4M',
'J4N',
'J4P',
'J4R',
'J4S',
'J4T',
'J4V',
'J4W',
'J4X',
'J4Y',
'J4Z',
'J5A',
'J5J',
'J5K',
'J5L',
'J5M',
'J5R',
'J5T',
'J5W',
'J5X',
'J5Y',
'J5Z',
'J6A',
'J6E',
'J6J',
'J6K',
'J6N',
'J6R',
'J6S',
'J6T',
'J6V',
'J6W',
'J6X',
'J6Y',
'J6Z',
'J7A',
'J7B',
'J7C',
'J7E',
'J7G',
'J7H',
'J7J',
'J7K',
'J7L',
'J7M',
'J7N',
'J7P',
'J7R',
'J7T',
'J7V',
'J7W',
'J7X',
'J7Y',
'J7Z',
'J8A',
'J8B',
'J8C',
'J8E',
'J8G',
'J8H',
'J8L',
'J8M',
'J8N',
'J8P',
'J8R',
'J8T',
'J8V',
'J8X',
'J8Y',
'J8Z',
'J9A',
'J9B',
'J9E',
'J9H',
'J9J',
'J9L',
'J5B',
'J5C',
'K0A',
'K0B',
'K0C',
'K0E',
'K0G',
'K0H',
'K0K',
'K0L',
'K0M',
'K1B',
'K1C',
'K1E',
'K1G',
'K1H',
'K1J',
'K1K',
'K1L',
'K1M',
'K1N',
'K1P',
'K1R',
'K1S',
'K1T',
'K1V',
'K1W',
'K1X',
'K1Y',
'K1Z',
'K2A',
'K2B',
'K2C',
'K2E',
'K2G',
'K2H',
'K2J',
'K2K',
'K2L',
'K2M',
'K2P',
'K2R',
'K2S',
'K2T',
'K2V',
'K2W',
'K4A',
'K4B',
'K4C',
'K4K',
'K4M',
'K4P',
'K4R',
'K6A',
'K6H',
'K6J',
'K6K',
'K6V',
'K7A',
'K7C',
'K7G',
'K7H',
'K7K',
'K7L',
'K7M',
'K7N',
'K7P',
'K7R',
'K7S',
'K7V',
'K8A',
'K8H',
'K8N',
'K8P',
'K8R',
'K8V',
'K9A',
'K9H',
'K9J',
'K9K',
'K9L',
'K9V',
'L0A',
'L0B',
'L0C',
'L0E',
'L0G',
'L0H',
'L0J',
'L0K',
'L0L',
'L0M',
'L0N',
'L0P',
'L0R',
'L0S',
'L1A',
'L1B',
'L1C',
'L1E',
'L1G',
'L1H',
'L1J',
'L1K',
'L1L',
'L1M',
'L1N',
'L1P',
'L1R',
'L1S',
'L1T',
'L1V',
'L1W',
'L1X',
'L1Y',
'L1Z',
'L2A',
'L2E',
'L2G',
'L2H',
'L2J',
'L2M',
'L2N',
'L2P',
'L2R',
'L2S',
'L2T',
'L2V',
'L2W',
'L3B',
'L3C',
'L3K',
'L3M',
'L3P',
'L3R',
'L3S',
'L3T',
'L3V',
'L3X',
'L3Y',
'L3Z',
'L4A',
'L4B',
'L4C',
'L4E',
'L4G',
'L4H',
'L4J',
'L4K',
'L4L',
'L4M',
'L4N',
'L4P',
'L4R',
'L4S',
'L4T',
'L4V',
'L4W',
'L4X',
'L4Y',
'L4Z',
'L5A',
'L5B',
'L5C',
'L5E',
'L5G',
'L5H',
'L5J',
'L5K',
'L5L',
'L5M',
'L5N',
'L5P',
'L5R',
'L5S',
'L5T',
'L5V',
'L5W',
'L6A',
'L6B',
'L6C',
'L6E',
'L6G',
'L6H',
'L6J',
'L6K',
'L6L',
'L6M',
'L6P',
'L6R',
'L6S',
'L6T',
'L6V',
'L6W',
'L6X',
'L6Y',
'L6Z',
'L7A',
'L7B',
'L7C',
'L7E',
'L7G',
'L7J',
'L7K',
'L7L',
'L7M',
'L7N',
'L7P',
'L7R',
'L7S',
'L7T',
'L8B',
'L8E',
'L8G',
'L8H',
'L8J',
'L8K',
'L8L',
'L8M',
'L8N',
'L8P',
'L8R',
'L8S',
'L8T',
'L8V',
'L8W',
'L9A',
'L9B',
'L9C',
'L9E',
'L9G',
'L9H',
'L9J',
'L9K',
'L9L',
'L9M',
'L9N',
'L9P',
'L9R',
'L9S',
'L9T',
'L9V',
'L9W',
'L9X',
'L9Z',
'M1B',
'M1C',
'M1E',
'M1G',
'M1H',
'M1J',
'M1K',
'M1L',
'M1M',
'M1N',
'M1P',
'M1R',
'M1S',
'M1T',
'M1V',
'M1W',
'M1X',
'M2H',
'M2J',
'M2K',
'M2L',
'M2M',
'M2N',
'M2P',
'M2R',
'M3A',
'M3B',
'M3C',
'M3H',
'M3J',
'M3K',
'M3L',
'M3M',
'M3N',
'M4A',
'M4B',
'M4C',
'M4E',
'M4G',
'M4H',
'M4J',
'M4K',
'M4L',
'M4M',
'M4N',
'M4P',
'M4R',
'M4S',
'M4T',
'M4V',
'M4Y',
'M5A',
'M5B',
'M5C',
'M5E',
'M5G',
'M5H',
'M5J',
'M5K',
'M5M',
'M5N',
'M5P',
'M5R',
'M5S',
'M5T',
'M5V',
'M5X',
'M6A',
'M6B',
'M6C',
'M6E',
'M6G',
'M6H',
'M6J',
'M6K',
'M6L',
'M6N',
'M6P',
'M6R',
'M6S',
'M8V',
'M8W',
'M8X',
'M8Y',
'M8Z',
'M9A',
'M9B',
'M9C',
'M9L',
'M9M',
'M9N',
'M9P',
'M9R',
'M9V',
'M9W',
'N0A',
'N0B',
'N0C',
'N0E',
'N0G',
'N0J',
'N0K',
'N0L',
'N0M',
'N0N',
'N0P',
'N0R',
'N1A',
'N1C',
'N1E',
'N1G',
'N1H',
'N1K',
'M4W',
'M4X',
'N1L',
'N1M',
'N1P',
'N1R',
'N1S',
'N1T',
'N2A',
'N2B',
'N2C',
'N2E',
'N2G',
'N2H',
'N2J',
'N2K',
'N2L',
'N2M',
'N2N',
'N2P',
'N2R',
'N2T',
'N2V',
'N2Z',
'N3A',
'N3B',
'N3C',
'N3E',
'N3H',
'N3L',
'N3P',
'N3R',
'N3S',
'N3T',
'N3V',
'N3W',
'N3Y',
'N4G',
'N4L',
'N4N',
'N4S',
'N4T',
'N4V',
'N4W',
'N4X',
'N4Z',
'N5A',
'N5C',
'N5H',
'N5P',
'N5R',
'N5V',
'N5W',
'N5X',
'N5Y',
'N5Z',
'N6A',
'N6B',
'N6C',
'N6E',
'N6G',
'N6H',
'N6J',
'N6K',
'N6L',
'N6M',
'N6N',
'N6P',
'N7A',
'N7G',
'N7L',
'N7M',
'N7S',
'N7T',
'N7V',
'N7W',
'N8A',
'N8H',
'N8M',
'N8N',
'N8P',
'N8R',
'N8S',
'N8T',
'N8W',
'N8X',
'N8Y',
'N9A',
'N9B',
'N9C',
'N9E',
'N9G',
'N9H',
'N9J',
'N9K',
'N9V',
'N9Y',
'P0B',
'P0E',
'P0M',
'P1L',
'P3A',
'P3B',
'P3C',
'P3E',
'P3L',
'P3N',
'P3Y',
'R0K',
'R1A',
'R1C',
'R2C',
'R2E',
'R2G',
'R2H',
'R2J',
'R2K',
'R2L',
'R2M',
'R2N',
'R2P',
'R2R',
'R2V',
'R2W',
'R2X',
'R2Y',
'R3A',
'R3B',
'R3C',
'R3E',
'R3G',
'R3H',
'R3J',
'R3K',
'R3L',
'R3M',
'R3N',
'R3P',
'R3R',
'R3T',
'R3V',
'R3W',
'R3X',
'R3Y',
'R4G',
'R4H',
'R4J',
'R5R',
'R7A',
'V4V',
'V5V',
'V6V',
'V7V',
'V8V',
'V9V',
'V1W',
'V2W',
'V3W',
'V4W',
'V5W',
'V6W',
'V7W',
'V8W',
'V1X',
'V2X',
'V3X',
'V4X',
'V5X',
'V6X',
'V8X',
'V9X',
'V1Y',
'V2Y',
'V3Y',
'V5Y',
'V6Y',
'V8Y',
'V9Y',
'V1Z',
'V2Z',
'V3Z',
'V4Z',
'V5Z',
'V6Z',
'V8Z',
'V9Z',
'V0E',
'V0H',
'V0K',
'V0M',
'V0N',
'V0R',
'V0X',
'T1A',
'T2A',
'T3A',
'T4A',
'T5A',
'T6A',
'T7A',
'T8A',
'T9A',
'T1B',
'T2B',
'T3B',
'T4B',
'T5B',
'T6B',
'T8B',
'T9M',
'T7P',
'T3V',
'T7V',
'T6Y',
'T0P',
'T0V',
'B1B',
'B1E',
'B1G',
'B1H',
'B1J',
'B1K',
'B1L',
'B1M',
'B1R',
'B1S',
'B1T',
'B1Y',
'C0A',
'C1B',
'C1C',
'E2H',
'E2R',
'E4J',
'E4R',
'E6B',
'E6C',
'E6G',
'E6L',
'G0E',
'G0K',
'G0N',
'G0P',
'G0Z',
'G1A',
'G3Z',
'G4R',
'G5H',
'G5J',
'G5T',
'G5Z',
'G6A',
'G6B',
'G6H',
'G6L',
'G6R',
'G7K',
'G7P',
'G7T',
'G7Y',
'G8A',
'G8C',
'G8G',
'G8J',
'G8M',
'G8V',
'G9C',
'G9X',
'H0M',
'H4Z',
'H5A',
'H5B',
'J1C',
'J1K',
'J1M',
'J1S',
'J1T',
'J1Z',
'J2A',
'J2E',
'J2N',
'J5V',
'K1A',
'K6T',
'K8B',
'M5L',
'M5W',
'M7A',
'M7R',
'M7Y',
'N4B',
'N5L',
'N7X',
'N8V',
'R7B',
'S0A',
'S0E',
'S0G',
'S0H',
'S0J',
'S0K',
'S0L',
'S0M',
'S3N',
'S4H',
'S4L',
'S4N',
'S4P',
'S4R',
'S4S',
'S4T',
'S4V',
'S4W',
'S4X',
'S4Y',
'S4Z',
'S6H',
'S6J',
'S6K',
'S6V',
'S6W',
'S6X',
'S7H',
'S7J',
'S7K',
'S7L',
'S7M',
'S7N',
'S7P',
'S7R',
'S7S',
'S7T',
'S7V',
'S7W',
'S9A',
'S9H',
'S9V',
'V2A',
'V3A',
'V4A',
'V5A',
'V6A',
'V7A',
'V9A',
'V1B',
'V2B',
'V3B',
'V4B',
'V5B',
'V6B',
'V7B',
'V8B',
'V9B',
'V1C',
'V2C',
'V5C',
'V6C',
'V7C',
'V8C',
'V9C',
'V1E',
'V2E',
'V3E',
'V4E',
'V5E',
'V6E',
'V7E',
'V8E',
'V9E',
'V1G',
'V2G',
'V3G',
'V4G',
'V5G',
'V6G',
'V7G',
'V9G',
'V1H',
'V2H',
'V3H',
'V5H',
'V6H',
'V7H',
'V9H',
'V2J',
'V3J',
'V5J',
'V6J',
'V7J',
'V1K',
'V2K',
'V3K',
'V4K',
'V5K',
'V6K',
'V7K',
'V9K',
'V1L',
'V2L',
'V3L',
'V4L',
'V5L',
'V6L',
'V7L',
'V8L',
'V9L',
'V1M',
'V2M',
'V3M',
'V4M',
'V5M',
'V6M',
'V7M',
'V8M',
'V9M',
'V1N',
'V2N',
'V3N',
'V4N',
'V5N',
'V3C',
'V4C',
'V6N',
'V7N',
'V8N',
'V9N',
'V1P',
'V2P',
'V4P',
'V5P',
'V6P',
'V7P',
'V8P',
'V9P',
'V1R',
'V2R',
'V3R',
'V4R',
'V5R',
'V6R',
'V7R',
'V8R',
'V9R',
'V1S',
'V2S',
'V3S',
'V4S',
'V5S',
'V6S',
'V7S',
'V8S',
'V9S',
'V1T',
'V2T',
'V3T',
'V4T',
'V5T',
'V6T',
'V7T',
'V8T',
'V9T',
'V1V',
'V2V',
'V3V',
'P1P',
'P3G',
'P3P',
'R1B',
'R3S',
'R5T',
'R7C',
'S0C',
'S0N',
'S0P',
'S2V',
'S4A',
'S4K',
'S4M',
'S7A',
'S7B',
'S7C',
'S9X',
'V1A',
'V8A',
'V8G',
'V1J',
'V8J',
'V9J',
'V8K',
'V9W',
'V7X',
'V7Y',
'V7Z',
'V0A',
'V0B',
'V0C',
'V0G',
'V0J',
'V0L',
'V0P',
'V0S',
'V0T',
'V0V',
'V0W',
'T1C',
'T2C',
'T3C',
'T4C',
'T5C',
'T6C',
'T8C',
'T9C',
'T2E',
'T3E',
'T4E',
'T5E',
'T6E',
'T7E',
'T8E',
'T9E',
'T1G',
'T2G',
'T3G',
'T4G',
'T5G',
'T6G',
'T8G',
'T9G',
'T1H',
'T2H',
'T3H',
'T4H',
'T5H',
'T6H',
'T8H',
'T9H',
'T1J',
'T2J',
'T3J',
'T4J',
'T5J',
'T6J',
'T9J',
'T1K',
'T2K',
'T3K',
'T5K',
'T6K',
'T9K',
'T1L',
'T2L',
'T3L',
'T4L',
'T5L',
'T6L',
'T8L',
'T1M',
'T2M',
'T3M',
'T4M',
'T5M',
'T6M',
'T2N',
'T3N',
'T4N',
'T5N',
'T6N',
'T7N',
'T8N',
'T9N',
'T1P',
'T2P',
'T3P',
'T4P',
'T5P',
'T6P',
'T1R',
'T2R',
'T3R',
'T4R',
'T5R',
'T6R',
'T8R',
'T1S',
'T2S',
'T3S',
'T4S',
'T5S',
'T6S',
'T7S',
'T8S',
'T9S',
'T2T',
'T3T',
'T4T',
'T5T',
'T6T',
'T8T',
'T1V',
'T4V',
'T5V',
'T6V',
'T8V',
'T9V',
'T1W',
'T2W',
'T5W',
'T6W',
'T8W',
'T9W',
'T1X',
'T2X',
'T4X',
'T5X',
'T6X',
'T7X',
'T8X',
'T9X',
'T1Y',
'T2Y',
'T5Y',
'T7Y',
'T1Z',
'T2Z',
'T3Z',
'T5Z',
'T7Z',
'T0A',
'T0B',
'T0C',
'T0E',
'T0G',
'T0H',
'T0J',
'T0K',
'T0L',
'T0M',
'A1A',
'A1B',
'A1C',
'A1E',
'A1G',
'A1H',
'A1K',
'A1L',
'A1M',
'A1N',
'A1S',
'A1W',
'A1X',
'B1A',
'B1C',
'B1N',
'B1P',
'B1V',
'B2A',
'B2R',
'B2V',
'B2W',
'B2X',
'B2Y',
'B3A',
'B3B',
'B3G',
'B3H',
'B3J',
'B3K',
'B3L',
'B3M',
'B3N',
'B3P',
'B3R',
'B3S',
'B3T',
'B3V',
'B4A',
'B4B',
'B4C',
'B4G',
'C1A',
'C1E',
'E1A',
'E1B',
'E1C',
'E1E',
'E1G',
'E1H',
'E1J',
'E2E',
'E2J',
'E2K',
'E2L',
'E2N',
'E2P',
'E2V',
'E3A',
'E3B',
'E3C',
'E3E',
'E3G',
'E4B',
'E4H',
'E4K',
'E4L',
'E4M',
'E4N',
'E4P',
'E4V',
'E9C',
'G0A',
'G0C',
'G0H',
'G0J',
'G0L',
'G0M',
'G0R',
'G0S',
'G0T',
'G0V',
'G0W',
'G0X',
'G0Y',
'G1B',
'G1C',
'G1E',
'G1G',
'G1H',
'G1J',
'G1K',
'G1L',
'G1M',
'G1N',
'G1P',
'G1R',
'G1S',
'G1T',
'G1V',
'G1W',
'G1X',
'G1Y',
'G2A',
'G2B',
'G2C',
'G2E',
'G2G',
'G2J',
'G2K',
'G2L',
'G2M',
'G2N',
'G3A',
'G3B',
'G3C',
'G3E',
'G3G',
'G3H',
'G3J',
'G3K',
'G3L',
'G3M',
'G3N',
'G3S',
'G4A',
'G4S',
'G4V',
'G4W',
'G4X',
'G4Z',
'G5A',
'G5B',
'G5C',
'G5L',
'G5M',
'G5N',
'G5R',
'G5V',
'G5X',
'G5Y',
'G6C',
'G6E',
'G6G',
'G6J',
'G6K',
'G6P',
'G6S',
'G6T',
'G6V',
'G6W',
'G6X',
'G6Y',
'G6Z',
'G7A',
'G7B',
'G7G',
'G7H',
'G7J',
'G7N',
'G7S',
'G7X',
'G7Z',
'G8B',
'G8E',
'G8H',
'G8K',
'G8L',
'G8N',
'G8T',
'G8W',
'G8Y',
'G8Z',
'G9A',
'G9B',
'G9H',
'G9N',
'G9P',
'G9R',
'G9T',
'H1A',
'H1B',
'H1C',
'H1E',
'H1G',
'H1H',
'H1J',
'H1K',
'H1L',
'H1M',
'H1N',
'H1P',
'H1R',
'H1S',
'H1T',
'H1V',
'H1W',
'H1X',
'H1Y',
'H1Z',
'H2A',
'H2B',
'H2C',
'H2E',
'H2G',
'H2H',
'H2J',
'H2K',
'H2L',
'H2M',
'H2N',
'H2P',
'H2R',
'H2S',
'H2T',
'H2V',
'H2W',
'H2X',
'H2Y',
'H2Z',
'H3A'
];

export default canadianPostalCodes;

